// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import addStatusMessage from './addStatusMessage';
import clearStatusMessages from './clearStatusMessages';
import escapeHtml from './escapeHtml';

export const prepareInternalError = (
    message,
    {
        messageWrapper = 'pre',
    } = {},
) => {
    let statusMessage = `Internal error<${messageWrapper}>${escapeHtml(message)}</${messageWrapper}>`;
    try {
        const jsonMessage = JSON.parse(message);
        if ('message' in jsonMessage && 'kbArticleUrl' in jsonMessage) {
            statusMessage = `<${messageWrapper}>${escapeHtml(jsonMessage.message)}</${messageWrapper}>`;
            statusMessage += `<a href="${jsonMessage.kbArticleUrl}" target="_blank">Search for related Knowledge Base articles</a>`;
        }
    } catch {
        // Show as plaintext
    }

    return statusMessage;
};

export default message => {
    clearStatusMessages();

    addStatusMessage('error', prepareInternalError(message));
};
